module.exports = __webpack_public_path__ + "static/media/screenshots@3x.473b8e09.png";